<template>
	<div class="footer">
		<div>
			<div class="customerServiceInformation">
				<div class="serviceTel">
					<div class="companyName">安徽亿众</div>
					<p>
						<i class="iconfont icon-dianhua"></i>
						<span>
							<i>客服电话：</i>
							<i>{{this.$store.state.user.generalSetting.serviceTel}}</i>
						</span>
					</p>
					<p>
						<i class="iconfont icon-dizhi"></i>
						<span>
							<i>地址：</i>
							<i>{{this.$store.state.user.generalSetting.address}}</i>
						</span>
					</p>
				</div>
				<div class="QR_code">
					<div class="wechartCode" v-for="(item,index) in this.$store.state.user.generalSetting.footerQRCode"
						:key="index">
						<img :src="item.imgPath">
						<p>{{item.describe}}</p>
					</div>
				</div>
			</div>
			<div class="footer-floor2">
				<p>
					©{{year+this.$store.state.user.generalSetting.copyright}} <a target="_blank"
						href="https://beian.miit.gov.cn">{{this.$store.state.user.generalSetting.archivalInfo}}</a><i
						v-if="this.$store.state.user.generalSetting.businessCertificate">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;增值电信业务经营许可证:{{this.$store.state.user.generalSetting.businessCertificate}}</i>
					<a target="_blank" v-if="this.$store.state.user.generalSetting.beijingPublicNetworkSecurity"
						href="http://www.beian.gov.cn/portal/registerSystemInfo">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.$store.state.user.generalSetting.beijingPublicNetworkSecurity}}</a>

				</p>
			</div>

		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				year: ''

			}
		},
		mounted() {
			var nowYear = new Date();
			this.year = nowYear.getFullYear();
		}

	}
</script>

<style scoped lang="less">
	.footer {
		width: 100%;
		background: #979797;

		>div {
			width: 1200px;
			margin: 0 auto;
		}

	}


	.customerServiceInformation {
		padding: 50px 64px 19px 75px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #D4D7DC;
	}

	.serviceTel {
		width: 66%;
	}

	.companyName {
		font-size: 26px;
		font-weight: bold;
		color: #fff;
		margin-bottom: 30px;
	}

	.serviceTel p .iconfont {
		font-size: 20px;
		color: #fff;
		vertical-align: middle;
		margin-right: 8px;
	}

	.serviceTel p {
		font-size: 16px;
		color: #fff;
		margin-bottom: 20px;
	}

	.serviceTel p span i:first-child {
		display: inline-block;
	}

	.QR_code {
		overflow: hidden;
	}

	.QR_code p {
		font-size: 16px;
		font-weight: 400;
		color: #fff;
		line-height: 14px;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.QR_code>div {
		width: 146px;
		float: left;
		text-align: center;

		img {
			width: 127px;
			height: 127px;
			object-fit: contain;
			margin-bottom: 10px;
		}
	}

	.footer-floor2 {
		width: 1168px;
		margin: 0 auto;
		text-align: center;
		border-top-color: #D4D7DC;
	}

	.footer-floor2 p {
		text-align: center;
		font-size: 12px;
		line-height: 66px;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.footer-floor2 a {
		cursor: pointer;
		color: #fff;
	}
</style>